.banner {
	padding: 12px;
	border-radius: 8px;
	background-color: #F9F8FF;
	border: 1px solid #C0B9EC;
}

.banner :global(.MuiStack-root) {
	min-width: 0;
}

.banner svg {
	flex-shrink: 0;
}

.list {
	margin: 0;
	padding-left: 20px;
}

.listItem {
	color: #333333;
}

.errorHeader:global(.MuiTypography-root) {
	font-family: "Inter";
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0px;

	color: #333333;
	min-width: 0;
}

.text:global(.MuiTypography-root) {
	font-family: "Inter";
	font-weight: 400;
	font-size: 14px;
	line-height: 150%;
	letter-spacing: 0px;

	color: #333333;
	min-width: 0;
	overflow-wrap: anywhere;
}
